import React from 'react';
import { Circle } from '@wegroup/design-system';

const ComparisonBarVS: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Circle
      bg="primary.50"
      color="primary.500"
      size={{ base: '6', laptop: '8' }}
      textStyle="smallBodyBold"
    >
      VS
    </Circle>
  );
};

export default ComparisonBarVS;
